import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import { Box, Modal, Tooltip } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";

import Checkbox from "@mui/material/Checkbox";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import UncheckIcon from "assets/svgIcons/UncheckIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import ChatIcon from "assets/svgIcons/ChatDoubleIcon";
import AudioIcon from "assets/svgIcons/AudioIcon";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import ExpandMoreNormalIcon from "@mui/icons-material/ExpandMore";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import DummyFoodImage from "assets/images/dummy-food-img.png";
import { AccordionStyled, PopUpContainer } from "assets/css/globle";
import { Loader } from "commonComponents/Loader/Loader";
import _ from "lodash";
import {
  Container,
  HeaderWrapper,
  BodyWrapper,
  TopSection,
  MenuSection,
  Filter,
  PromptAccept,
  ItemSection,
  HoursSection,
  GroupItemSection,
  FoodItems,
  ItemsWrapper
} from "pages/FoodAndBeverages/FBSettings/FoodAndBeveragesStyled";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { FB_GLOBAL_STATES, SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { API_STATUSES } from "redux/_helpers/statuses";
import { useTranslation } from "react-i18next";
import { useHookstate } from "@hookstate/core";
import AddItem from "./addItem";
import AddGroup from "./addGroup";
import AlertModal from "../../../commonComponents/Popup/alertModal";
import { Hours, Minutes } from "./Constant";
import FoodMenuFilter from "./FoodMenuFilter";
import FoodOrderHours from "./FoodOrderHours";
import { isUserBasic, isUserReadOnly, featureKey } from "constant";

const FBSettings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    siteSettingsData,
    getFoodMenuTabDataState,
    getFoodMenuTabDataStatus,
    sharedCheckboxStatusReduxState,
    getUserRole,
    putFoodMenuTabDataStateAction
  } = useSelector((state) => state.commonReducers) || [];

  const { FoodBevEnabled } = siteSettingsData;
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { fbOrdersSettings } = useHookstate(FB_GLOBAL_STATES);

  const [list, setList] = useState([]);
  const [updatedPriceList, setUpdatedPriceList] = useState([]);
  const [expandSubGroup, setExpandSubGroup] = useState([]);
  const [openDeleteItemAlert, setOpenDeleteItemAlert] = useState(false);
  const [getDeleteValues, setDeleteValues] = useState("");
  const [getDeleteValuesForChild, setDeleteValuesForChild] = useState("");
  const [foodMenu, setFoodMenu] = useState([]);
  const [compareFoodMenu, setCompareFoodMenu] = useState(getFoodMenuTabDataState);
  const [holes, setHoles] = useState([]);
  const [selectedHours, setSelectedHoures] = useState({
    OperationHoursStartInUtc: "",
    OperationHoursStopInUtc: "",
  });
  const [toggleLoader, setToggleLoader] = useState(false);
  const [checkedSharedCheckbox, setCheckedSharedCheckbox] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [tabValue, setTabValue] = useState("");
  const [nextItemId] = useState([600, 600, 600]);
  const [descriptionValidationAlert, setDescriptionValidationAlert] = useState(false);
  const [initialList, setInitialList] = useState({ initial: null });
  const [cancelChanges, setCancelChanges] = useState(false);
  const [cancelMenuChanges, setCancelMenuChanges] = useState(false);
  const [sharedMenuChange, setSharedMenuChange] = useState(false);
  const [isFoodEnable, setIsFoodEnable] = useState(FoodBevEnabled);
  const [isLoading, setIsloading] = useState(false);
  const [isSaveMenuDisabled, setIsSaveMenuDisabled] = useState(true);

  useEffect(() => {
      if(Object.keys(siteSettingsData).length > 0) {
        if(siteSettingsData?.Features?.indexOf(featureKey.golf) <= 0) {
          navigate("/dashboard", { replace: true });
        }
      }
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    setUpdatedPriceList([...list]);
  }, [list]);

  useEffect(() => {
    if (getFoodMenuTabDataState?.Courses && getFoodMenuTabDataState?.Courses[0]?.Holes) {
      //Holes
      let holesData = getFoodMenuTabDataState?.Courses?.map((v) => v.Holes);
      setHoles(holesData);

      //Hours
      const operationHours = getFoodMenuTabDataState.Courses.map((v) => {
        return {
          OperationHoursStartInUtc: v.OperationHoursStartInUtc,
          OperationHoursStopInUtc: v.OperationHoursStopInUtc,
        };
      });

      setSelectedHoures(operationHours);

      //FoodMenu List
      let mainListObj = [];
      let foodMenuList = [];

      let groupOrList = "";
      let ItemNumber = "";
      let subItemNumber = "";

      getFoodMenuTabDataState.Courses.forEach((items) => {
        items?.Items.forEach((v) => {
          if (v.Type === 1 && v.ParentItemNumber === 0) {
            groupOrList = "group";
            ItemNumber = v.ItemNumber;
            mainListObj.push({
              group: {
                parent: [
                  {
                    title: v.Description,
                    price: Number(v.Price).toFixed(2),
                    image: v.ImageFileName,
                    itemNumber: v.ItemNumber,
                    expand: false,
                  },
                ],
                child: [],
              },
              item: [],
            });
          }
          if (v.Type !== 1 && v.ParentItemNumber === 0) {
            groupOrList = "item";
            ItemNumber = v.ItemNumber;
            mainListObj.push({
              item: {
                parent: [
                  {
                    title: v.Description,
                    price: Number(v.Price).toFixed(2),
                    image: v.ImageFileName,
                    itemNumber: v.ItemNumber,
                    expand: false,
                  },
                ],
                child: [],
              },
              group: [],
            });
          }

          if (
            groupOrList === "group" &&
            v.ParentItemNumber &&
            v.ParentItemNumber === ItemNumber &&
            v.MenuLevel === 1
          ) {
            let lastItem = mainListObj.length - 1;
            subItemNumber = v.ItemNumber;
            mainListObj[lastItem].group.child = [
              ...mainListObj[lastItem].group.child,
              {
                title: v.Description,
                price: Number(v.Price).toFixed(2),
                image: v.ImageFileName,
                subChild: [],
                itemNumber: v.ItemNumber,
                expand: false,
              },
            ];
          }
          if (
            groupOrList === "item" &&
            v.ParentItemNumber &&
            v.ParentItemNumber === ItemNumber &&
            v.MenuLevel === 1
          ) {
            let lastItem = mainListObj.length - 1;
            mainListObj[lastItem].item.child = [
              ...mainListObj[lastItem].item.child,
              {
                title: v.Description,
                price: Number(v.Price).toFixed(2),
                image: v.ImageFileName,
                itemNumber: v.ItemNumber,
                expand: false,
              },
            ];
          }
          if (
            v.ParentItemNumber &&
            v.ParentItemNumber === subItemNumber &&
            v.MenuLevel === 2
          ) {
            let lastItem = mainListObj.length - 1;
            let lastSubchild = mainListObj[lastItem].group.child.length - 1;
            mainListObj[lastItem].group.child[lastSubchild].subChild = [
              ...mainListObj[lastItem].group.child[lastSubchild].subChild,
              {
                title: v.Description,
                price: Number(v.Price).toFixed(2),
                image: v.ImageFileName,
                itemNumber: v.ItemNumber,
              },
            ];
          }
        });
        foodMenuList.push(mainListObj);
        mainListObj = [];
      });

      setList(foodMenuList);
    }

    if (getFoodMenuTabDataState && siteSettingsData && Object.keys(getFoodMenuTabDataState).length !== 0 &&
        Object.keys(siteSettingsData).length !== 0 &&
        siteSettingsData?.Courses.length >= 1 &&
        getFoodMenuTabDataState?.Courses &&
        getFoodMenuTabDataState?.Courses.length !== 0) {
      if (getFoodMenuTabDataState?.Courses[0]?.CourseNumber === 0) {
        setCheckedSharedCheckbox(true);
        setTabValue(getFoodMenuTabDataState?.Courses[0]?.CourseNumber?.toString());
      } else {
        setTabValue(getFoodMenuTabDataState?.Courses[0]?.CourseNumber?.toString());
        setCheckedSharedCheckbox(false);
      }
    }

    setFoodMenu(getFoodMenuTabDataState);
    setCompareFoodMenu(getFoodMenuTabDataState);

    for (let i = 0; i < getFoodMenuTabDataState?.Courses?.length; i++) {
      nextItemId[i] = getFoodMenuTabDataState?.Courses[i]?.NextItemId;
    }
    if (cancelChanges) setCancelChanges(false);
  }, [getFoodMenuTabDataState, cancelChanges]);

  useEffect(() => {
    if ((initialList.initial === null && list.length !== 0) || sharedMenuChange) {
      setInitialList({ initial: removeExpand(list) });
    }
    setSharedMenuChange(false);
  }, [list]);

  useEffect(() => {
    if (sharedCheckboxStatusReduxState === "success") {
      dispatch(COMMON_SERVICES.getFoodMenuTabServices(siteId.get()));
    }
  }, [sharedCheckboxStatusReduxState]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getFoodImageNamesDataServices(siteId.get()));
    dispatch(COMMON_SERVICES.getFoodMenuTabServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    if(putFoodMenuTabDataStateAction) {
      dispatch(COMMON_SERVICES.getFoodMenuTabServices(siteId.get()));
    }
  }, [putFoodMenuTabDataStateAction]);

  const handleSharedMenusTabChange = (event, newValue) => {
    setTabValue(newValue?.toString());
  }

  const handleOnChangeShowOrder = (e, target) => {
    const orderSettingsObj = { ...fbOrdersSettings.get() };

    orderSettingsObj[target] = e.target.checked;

    fbOrdersSettings.set({
      ...orderSettingsObj,
    });
    const fbOrderSettings = JSON.stringify({ ...orderSettingsObj });

    localStorage.setItem("fbOrdersSettings", fbOrderSettings);
  }

  async function handleOnChange(e) {
    let payload = e.target.checked;
    setIsFoodEnable(payload);
    await dispatch(
      COMMON_SERVICES.putFoodEnabledService(siteId.get(), payload)
    );
  }

  const toggleAcordion = (e, courseIndex, i, listType) => {
    e.stopPropagation();
    let temp = list;
    temp[courseIndex][i][listType]["parent"][0].expand =
      !temp[courseIndex][i][listType]["parent"][0].expand;

    setList([...temp]);
  }

  const toggleAcordionSubGroup = (e, parentIndex, i, listType, index) => {
    e.stopPropagation();

    list[parentIndex][i][listType]["child"][index].expand =
      !list[parentIndex][i][listType]["child"][index].expand;
    setList([...list]);
  }

  //################################## Add Table FEATURE  ##########################################//

  const addField = (target, parentIndex) => {
    let fields = list;

    let selectedIndexValue = list[parentIndex];
    let data = {};
    data["group"] = [];
    data["item"] = [];
    data[target]["parent"] = [
      {
        title: "",
        price: "0.00",
        image: "",
        itemNumber: nextItemId[parentIndex],
        expand: false,
      },
    ];
    selectedIndexValue.push(data);
    fields[parentIndex] = selectedIndexValue;
    setList([...fields]);

    nextItemId[parentIndex] = nextItemId[parentIndex] + 1;
  }

  const handleOnAddButton = (i, target, parentIndex, e) => {
    e.stopPropagation();

    let fields = list[parentIndex];

    let selectedIndexValue = [...list];
    if (fields[i][target]["child"]) {
      fields[i][target]["child"] = [
        {
          title: "",
          price: "0.00",
          image: "",
          itemNumber: nextItemId[parentIndex],
        },
        ...fields[i][target]["child"],
      ];
    } else {
      fields[i][target]["child"] = [
        {
          title: "",
          price: "0.00",
          image: "",
          itemNumber: nextItemId[parentIndex],
        },
      ];
    }
    selectedIndexValue[parentIndex] = fields;
    selectedIndexValue[parentIndex][i][target].parent[0].expand = true;
    setList([...selectedIndexValue]);

    nextItemId[parentIndex] = nextItemId[parentIndex] + 1;
  }

  const addSubchild = (e, i, index, parentIndex) => {
      e.stopPropagation();

    // Step 1: Expand the subgroup visually
    const newExpandSubGroup = [...expandSubGroup];
    newExpandSubGroup[index] = true;
    setExpandSubGroup(newExpandSubGroup);

    // Step 2: Clone list safely and locate the path
    const updatedList = [...list];
    const parentFields = [...(updatedList[parentIndex] || [])];
    const targetItem = { ...(parentFields[i] || {}) };

    const targetGroup = { ...(targetItem.group || {}) };
    const groupChildren = [...(targetGroup.child || [])];
    const targetChild = { ...(groupChildren[index] || {}) };

    const existingSubChildren = [...(targetChild.subChild || [])];

    // Step 3: Create new subChild
    const newItemNumber = nextItemId[parentIndex];
    const newSubChild = {
      title: "",
      price: "0.00",
      image: "",
      itemNumber: newItemNumber,
    };

    // Step 4: Add new subChild at the end (append to preserve order)
    targetChild.subChild = [...existingSubChildren, newSubChild];
    targetChild.expand = true;

    groupChildren[index] = targetChild;
    targetGroup.child = groupChildren;
    targetItem.group = targetGroup;
    parentFields[i] = targetItem;
    updatedList[parentIndex] = parentFields;

    setList(updatedList);

    // Step 5: Create corresponding payload item
    const newPayloadItem = {
      Type: 2,
      ItemNumber: newItemNumber,
      Description: "",
      ImageFileName: "",
      Price: 0.0,
      Taxable: false,
      MenuLevel: 2,
      ParentItemNumber: targetChild.itemNumber,
      IsHighlighted: false,
      ChildCount: 0,
      IsCollapsed: false,
      DescriptionPaddingLeft: "125px",
      DescriptionColumnSpan: 1,
      BackgroundColor: "#FFFFFF",
      IsRowVisible: true,
      IsRowJustAddedOrMoved: false,
      formattedPrice: 0.0,
    };

    // Step 6: Update foodMenu
    const updatedCourses = [...foodMenu.Courses];
    const course = { ...updatedCourses[parentIndex] };
    const items = [...(course.Items || []), newPayloadItem];

    course.Items = items;
    updatedCourses[parentIndex] = course;

    setFoodMenu((prev) => ({
      ...prev,
      Courses: updatedCourses,
    }));

    // Step 7: Increment item ID
    nextItemId[parentIndex] = newItemNumber + 1;
  }

  //################################## End FEATURE  ##########################################//

  //################################## Delete FEATURE  ##########################################//

  const handleOnDeleteSubmit = () => {
    handleOnConfirmDelete();
    setOpenDeleteItemAlert(false);
  }

  const handleOnConfirmDelete = () => {
    let updatedList = [...list];

    if (getDeleteValues) {
      const { i, index, target, type, parentIndex } = getDeleteValues;

      if (type === "parent") {
        updatedList[parentIndex] = [...updatedList[parentIndex]];
        updatedList[parentIndex].splice(i, 1);
      }

      if (type === "child" && index != null) {
        updatedList[parentIndex] = [...updatedList[parentIndex]];
        updatedList[parentIndex][i] = {
          ...updatedList[parentIndex][i],
          [target]: {
            ...updatedList[parentIndex][i][target],
            [type]: [...updatedList[parentIndex][i][target][type]]
          }
        };

        updatedList[parentIndex][i][target][type].splice(index, 1);
      }

      setDeleteValues("");
    }

    if (getDeleteValuesForChild) {
      const { i, index, subChildIndex, parentIndex } = getDeleteValuesForChild;

      updatedList[parentIndex] = [...updatedList[parentIndex]];
      updatedList[parentIndex][i] = {
        ...updatedList[parentIndex][i],
        group: {
          ...updatedList[parentIndex][i].group,
          child: [...updatedList[parentIndex][i].group.child]
        }
      };

      updatedList[parentIndex][i].group.child[index] = {
        ...updatedList[parentIndex][i].group.child[index],
        subChild: [
          ...updatedList[parentIndex][i].group.child[index].subChild
        ]
      };

      updatedList[parentIndex][i].group.child[index].subChild.splice(subChildIndex, 1);
      setDeleteValuesForChild("");
    }

    setList(updatedList);
  }

  const handleOnDelete = (
    i,
    index,
    target,
    type,
    title,
    parentIndex,
    ItemNumber,
    e
  ) => {
    e.stopPropagation();
    setIsSaveMenuDisabled(false);

    setDeleteValues({
      i: i,
      parentIndex: parentIndex,
      index: index,
      target: target,
      type: type,
      title: title,
      ItemNumber: ItemNumber,
    });
    setOpenDeleteItemAlert(true);
  }

  const handleOnDeleteSubChild = (
    i,
    index,
    subChildIndex,
    parentIndex,
    title,
    e,
    itemNumber
  ) => {
    e.stopPropagation();
    setIsSaveMenuDisabled(false);

    setDeleteValuesForChild({
      i: i,
      index: index,
      subChildIndex: subChildIndex,
      parentIndex: parentIndex,
      title: title,
      itemNumber: itemNumber,
    });
    setOpenDeleteItemAlert(true);
  }

  //################################## End FEATURE  ##########################################//

  useEffect(() => {
    setIsloading(false);
    setIsFoodEnable(FoodBevEnabled);
  }, [FoodBevEnabled]);

  //################################## UP & DOWN FEATURE  ##########################################//
  //*******************PARENT****************************//
  const reorderArray = (event, originalArray, parentIndex) => {
    let copyArr = [...originalArray];
    let copyList = originalArray[parentIndex];
    const movedItem = copyList.find((item, index) => index === event.oldIndex);
    const remainingItems = copyList.filter(
      (item, index) => index !== event.oldIndex
    );

    const reorderedItems = [
      ...remainingItems.slice(0, event.newIndex),
      movedItem,
      ...remainingItems.slice(event.newIndex),
    ];
    copyArr[parentIndex] = reorderedItems;

    return copyArr;
  };

  function changeOrder(index, parentIndex, direction, e, level, itemNumber) {
    e.stopPropagation();
    setIsSaveMenuDisabled(false);

    if (index === 0 && direction === "UP") {
      return;
    }
    let lastIndex = list[parentIndex];
    if (lastIndex === index && direction === "DOWN") {
      return;
    }
    setList(
      reorderArray(
        { oldIndex: index, newIndex: index + (direction === "UP" ? -1 : 1) },
        list,
        parentIndex
      )
    );

    let items = [...foodMenu.Courses[parentIndex].Items];
    let currentLevelItems = items.filter((data) => data.MenuLevel === level);
    let clickedIndexCL = currentLevelItems.findIndex(
      (data) => data.ItemNumber === itemNumber
    );

    let nearElementCL;
    direction === "UP"
      ? (nearElementCL = currentLevelItems[clickedIndexCL - 1])
      : (nearElementCL = currentLevelItems[clickedIndexCL + 1]);

    let clickedIndexFM = items.findIndex(
      (data) => data.ItemNumber === currentLevelItems[clickedIndexCL].ItemNumber
    );
    let aboveIndexFM = items.findIndex(
      (data) => data.ItemNumber === nearElementCL.ItemNumber
    );

    let temp = items[clickedIndexFM];
    items[clickedIndexFM] = items[aboveIndexFM];
    items[aboveIndexFM] = temp;
  }
  //**********************PARENT***********************//

  //*************************CHILD************************//
  const reorderArrayChild = (
    event,
    i,
    parentIndex,
    target,
    originalArray
  ) => {
    let copyArr = [...originalArray];
    let copyList = originalArray[parentIndex][i][target]["child"];
    const movedItem = copyList.find((item, index) => index === event.oldIndex);
    const remainingItems = copyList.filter(
      (item, index) => index !== event.oldIndex
    );

    const reorderedItems = [
      ...remainingItems.slice(0, event.newIndex),
      movedItem,
      ...remainingItems.slice(event.newIndex),
    ];
    copyArr[parentIndex][i][target]["child"] = reorderedItems;
    return copyArr;
  }

  function shiftUpDownChild(parentIndex, i, index, target, direction) {
    setIsSaveMenuDisabled(false);

    if (index === 0 && direction === "UPARROW") {
      return;
    }
    let lastIndex = list[parentIndex][i][target]["child"].length - 1;
    if (lastIndex === index && direction === "DOWNARROW") {
      return;
    }
    setList(
      reorderArrayChild(
        {
          oldIndex: index,
          newIndex: index + (direction === "UPARROW" ? -1 : 1),
        },
        i,
        parentIndex,
        target,
        list
      )
    );
  }
  //***********************CHILD ENDS************************************//
  //*************************SUBCHILD************************//
  const reorderArraySubChild = (
    event,
    i,
    index,
    parentIndex,
    originalArray
  ) => {
    let copyArr = [...originalArray];
    let copyList = originalArray[parentIndex][i]["group"]["child"][index]["subChild"];

    const movedItem = copyList.find((item, index) => index === event.oldIndex);
    const remainingItems = copyList.filter(
      (item, index) => index !== event.oldIndex
    );

    const reorderedItems = [
      ...remainingItems.slice(0, event.newIndex),
      movedItem,
      ...remainingItems.slice(event.newIndex),
    ];
    copyArr[parentIndex][i]["group"]["child"][index]["subChild"] =
      reorderedItems;
    return copyArr;
  }

  function shiftUpSubChild(parentIndex, i, index, subChildIndex, direction) {
    setIsSaveMenuDisabled(false);

    if (subChildIndex === 0 && direction === "UPARROW") {
      return;
    }
    let lastIndex =
      list[parentIndex][i]["group"]["child"][index]["subChild"].length - 1;
    if (lastIndex === index && direction === "DOWNARROW") {
      return;
    }
    setList(
      reorderArraySubChild(
        {
          oldIndex: subChildIndex,
          newIndex: subChildIndex + (direction === "UPARROW" ? -1 : 1),
        },
        i,
        index,
        parentIndex,
        list
      )
    );
  }
  //*************************SUBCHILD ENDS***********************//

  const shiftUp = (i, index) => {
    setIsSaveMenuDisabled(false);

    if (index === null && i > 0) {
      let fields = list;
      const temp = fields[i];
      fields[i] = fields[i + 1];
      fields[i + 1] = temp;
      setList([...fields]);
    }
  }

  const shiftDown = (i, index) => {
    setIsSaveMenuDisabled(false);

    if (index === null && i > 0) {
      let fields = list;
      const temp = fields[i];
      fields[i] = fields[i - 1];
      fields[i - 1] = temp;
      setList([...fields]);
    }
  }

  const handleOnChangeTitle = (
    e,
    listType,
    level,
    parentIndex,
    i,
    ItemNumber,
    childIndex,
    subChildIndex
  ) => {
    setIsSaveMenuDisabled(false);

    const val = e.target.value;

    // Shallow copy list
    const newList = [...list];

    // Defensive init
    if (!newList[parentIndex]) newList[parentIndex] = [];
    if (!newList[parentIndex][i]) newList[parentIndex][i] = {};
    if (!newList[parentIndex][i][listType]) newList[parentIndex][i][listType] = {};
    if (!newList[parentIndex][i][listType][level]) {
      newList[parentIndex][i][listType][level] = level === "subChild" ? [] : [];
    }

    if (level === "subChild") {
      if (!newList[parentIndex][i][listType]["child"]) {
        console.warn("Missing child/subChild structure.");
        return;
      }

      const subChildren = newList[parentIndex][i][listType]["child"][childIndex][level] ??= [];
      const existing = subChildren[subChildIndex] ??= { itemNumber: ItemNumber };
      existing.title = val;
    } else {
      const itemList = newList[parentIndex][i][listType][level];
      const idx = itemList.findIndex((x) => x.itemNumber === ItemNumber);

      if (idx !== -1) {
        itemList[idx] = { ...itemList[idx], title: val };
      } else {
        itemList.push({ itemNumber: ItemNumber, title: val });
      }
    }

    setList(newList);

    // 🔁 Also update foodMenu (optional but should be shallow!)
    setFoodMenu((prev) => {
      const newCourses = [...prev.Courses];
      const course = { ...newCourses[parentIndex] };
      const items = [...course.Items];
      const index = items.findIndex((x) => x.ItemNumber === ItemNumber);

      if (index !== -1) {
        items[index] = { ...items[index], Description: val };
      } else {
        items.push({ ItemNumber, Description: val });
      }

      course.Items = items;
      newCourses[parentIndex] = course;
      return { ...prev, Courses: newCourses };
    });
  }

  const handleOnChangePrice = (
    e,
    listType,
    level,
    parentIndex,
    i,
    childIndex,
    ItemNumber,
    subChildIndex
  ) => {
    setIsSaveMenuDisabled(false);

    if (listType === "item") {
      if (level === "subChild") {
        list[parentIndex][i][listType]["child"][childIndex][level][
          subChildIndex
        ].price = e.target.value;
      } else if (level === "parent")
        list[parentIndex][i][listType][level][0].price = e.target.value;
      else
        list[parentIndex][i][listType][level][childIndex].price = e.target.value;
    }

    if (listType === "group") {
      if (level === "subChild") {
        list[parentIndex][i]["group"]["child"][childIndex][level][
          subChildIndex
        ].price = e.target.value;
      } else
        list[parentIndex][i][listType][level][childIndex].price = e.target.value;
    }

    let copyFoodMenu = [...foodMenu["Courses"][parentIndex].Items];
    let Alldata = { ...foodMenu };
    let index = foodMenu?.Courses[parentIndex]?.Items?.findIndex(
      (v) => v.ItemNumber === ItemNumber
    );

    let food = [...Alldata["Courses"]];
    copyFoodMenu[i] = {
      ...foodMenu.Courses[parentIndex].Items[index],
      Price: e.target.value,
    };

    food[parentIndex] = {
      CourseNumber: food[parentIndex].CourseNumber,
      Holes: food[parentIndex].Holes,
      Instructions: food[parentIndex].Instructions,
      Items: copyFoodMenu,
      NextItemId: food[parentIndex].NextItemId,
      OperationHoursStartInUtc: food[parentIndex].OperationHoursStartInUtc,
      OperationHoursStopInUtc: food[parentIndex].OperationHoursStopInUtc,
      ServiceCharge: food[parentIndex].ServiceCharge,
      ServiceChargePostTax: food[parentIndex].ServiceChargePostTax,
      TaxPercentage: food[parentIndex].TaxPercentage,
      TaxService: food[parentIndex].TaxService,
      Title: food[parentIndex].Title,
    };

    let copyList = [...list];
    setUpdatedPriceList([...copyList]);
  }

  //################################## End of FEATURE  ##########################################//

  //################################## Prompt and Accept Feature  #######################################
  const handleOnSelectHoles = (parentIndex, target, index, status) => {
    setIsSaveMenuDisabled(false);

    let data = [...holes[parentIndex]];
    let copyOfHoleData = [...holes];
    let Alldata = { ...foodMenu };
    if (target === "prompt") {
      data[index] = {
        ...data[index],
        CanAdvertise: data[index].CanAdvertise ? false : true,
      };
    }

    if (target === "accept") {
      data[index] = {
        ...data[index],
        CanOrderItems: data[index].CanOrderItems ? false : true,
      };
    }
    if (target === "allPrompt") {
      data = data.map((v) => ({ ...v, CanAdvertise: status }));
    }

    if (target === "allAccept") {
      data = data.map((v) => ({ ...v, CanOrderItems: status }));
    }
    copyOfHoleData[parentIndex] = data;
    setHoles([...copyOfHoleData]);
    let arr = [];
    arr = Alldata?.Courses.map((v, i) => {
      if (parentIndex === i) {
        return { ...v, Holes: data };
      }
      return v;
    });

    Alldata["Courses"] = [...arr];
    setFoodMenu(Alldata);
  }

  //################################## END FEATURE ##################################

  const handleOnChangeHours = (e, target, parentIndex) => {
    setIsSaveMenuDisabled(false);

    let data = [...selectedHours];
    let Alldata = { ...foodMenu };
    const value = e.target.value;

    if (target === "startHour") {
      data[parentIndex] = {
        OperationHoursStartInUtc: {
          Hour: value,
          Minute: data[parentIndex].OperationHoursStartInUtc.Minute,
        },
        OperationHoursStopInUtc: data[parentIndex].OperationHoursStopInUtc,
      };
    }
    if (target === "startMinute") {
      data[parentIndex] = {
        OperationHoursStartInUtc: {
          Hour: data[parentIndex].OperationHoursStartInUtc.Hour,
          Minute: value,
        },
        OperationHoursStopInUtc: data[parentIndex].OperationHoursStopInUtc,
      };
    }
    if (target === "endHour") {
      data[parentIndex] = {
        OperationHoursStartInUtc: data[parentIndex].OperationHoursStartInUtc,
        OperationHoursStopInUtc: {
          Hour: value,
          Minute: data[parentIndex].OperationHoursStopInUtc.Minute,
        },
      };
    }
    if (target === "endMinute") {
      data[parentIndex] = {
        OperationHoursStartInUtc: data[parentIndex].OperationHoursStartInUtc,
        OperationHoursStopInUtc: {
          Hour: data[parentIndex].OperationHoursStopInUtc.Hour,
          Minute: value,
        },
      };
    }

    setSelectedHoures(data);
    const changeInCourses = [...Alldata["Courses"]];
    changeInCourses[parentIndex] = {
      ...Alldata["Courses"][parentIndex],
      ...data[parentIndex],
    };
    setFoodMenu({
      Active: Alldata.Active,
      Courses: [...changeInCourses],
      SetId: Alldata.SetId,
    });
  }

  const calculateTotalValue = (parentIndex) => {
    let H = selectedHours[parentIndex].OperationHoursStopInUtc?.Hour - selectedHours[parentIndex].OperationHoursStartInUtc?.Hour;
    let M = selectedHours[parentIndex].OperationHoursStopInUtc?.Minute - selectedHours[parentIndex].OperationHoursStartInUtc?.Minute;

    if (M < 0) {
      M = 60 + M;
      H = H - 1;
    }
    return `${("0" + H).slice(-2)} : ${("0" + M).slice(-2)}`;
  }

  const validation = () => {
    let validationResult = true;
    updatedPriceList.map((courseMap) => {
      courseMap.forEach((itemListMap) => {
        if (itemListMap.group) {
          if (itemListMap.group.parent) {
            if (itemListMap.group.parent[0].title === "")
              validationResult = false;
          }
          if (itemListMap.group.child && itemListMap.group.child.length > 0) {
            itemListMap.group.child.map((groupChildMap) => {
              if (groupChildMap.title === "") validationResult = false;
              if (groupChildMap.subChild && groupChildMap.subChild.length > 0) {
                groupChildMap.subChild.map((subChildMap) => {
                  if (subChildMap.title === "") validationResult = false;
                });
              }
            });
          }
        }
        if (itemListMap.item) {
          if (itemListMap.item.parent) {
            if (itemListMap.item.parent[0].title === "")
              validationResult = false;
          }
          if (itemListMap.item.child && itemListMap.item.child.length > 0) {
            itemListMap.item.child.map((subChildMap) => {
              if (subChildMap.title === "") validationResult = false;
            });
          }
        }
      });
    });
    return validationResult;
  }

  const saveMenuChanges = () => {
    if (!validation()) {
      setDescriptionValidationAlert(true);
      return;
    }

    let courses = [];

    updatedPriceList.map((courseMap, courseMapIndex) => {
      courses[courseMapIndex] = [];
      courseMap.map((itemListMap) => {
        if (itemListMap.group) {
          if (itemListMap.group.parent) {
            addTopGroupAndItem(itemListMap.group.parent[0], courseMapIndex, 1);
          }
          if (itemListMap.group.child && itemListMap.group.child.length > 0) {
            itemListMap.group.child.map((groupChildMap) => {
              addSubItem(
                groupChildMap,
                courseMapIndex,
                0,
                itemListMap.group.parent[0].itemNumber
              );
              if (groupChildMap.subChild && groupChildMap.subChild.length > 0) {
                groupChildMap.subChild.map((subChildMap) => {
                  addSecondSubItem(
                    subChildMap,
                    courseMapIndex,
                    2,
                    groupChildMap.itemNumber
                  );
                });
              }
            });
          }
        }
        if (itemListMap.item) {
          if (itemListMap.item.parent) {
            addTopGroupAndItem(itemListMap.item.parent[0], courseMapIndex, 0);
          }
          if (itemListMap.item.child && itemListMap.item.child.length > 0) {
            itemListMap.item.child.map((subChildMap) => {
              addSecondSubItem(
                subChildMap,
                courseMapIndex,
                2,
                itemListMap.item.parent[0].itemNumber
              );
            });
          }
        }
      });

      setIsSaveMenuDisabled(true);
  });

  function addTopGroupAndItem(data, courseIndex, type) {
      let groupRecord = {
        ParentItemNumber: 0,
        MenuLevel: 0,
        IsHighlighted: false,
        IsCollapsed: true,
        DescriptionPaddingLeft: "10px",
        DescriptionColumnSpan: 2,
        BackgroundColor: "#FFFFFF",
        IsRowVisible: true,
        IsRowJustAddedOrMoved: false,
        ItemNumber: data.itemNumber,
        Description: data.title,
        ImageFileName: data.image,
        Price: data.price,
        Taxable: false,
        Type: type,
        SubItems: null,
        IsShowItemOnMenu: true,
      };
      courses[courseIndex].push(groupRecord);
  }

  function addSubItem(data, courseIndex, type, parentItemNumber) {
      let itemRecord = {
        Type: type,
        ItemNumber: data.itemNumber,
        Description: data.title,
        ImageFileName: data.image,
        Price: data.price,
        Taxable: false,
        MenuLevel: 1,
        ParentItemNumber: parentItemNumber,
        IsHighlighted: false,
        IsCollapsed: false,
        DescriptionPaddingLeft: "90px",
        DescriptionColumnSpan: 1,
        BackgroundColor: "#FFFFFF",
        IsRowVisible: true,
        IsRowJustAddedOrMoved: false,
        formattedPrice: 0.0,
      };
      courses[courseIndex].push(itemRecord);
  }

  function addSecondSubItem(data, courseIndex, type, parentItemNumber) {
      let subChildRecord = {
        Type: type,
        ItemNumber: data.itemNumber,
        Description: data.title,
        ImageFileName: data.image,
        Price: data.price,
        Taxable: false,
        MenuLevel: 2,
        ParentItemNumber: parentItemNumber,
        IsHighlighted: false,
        IsCollapsed: false,
        DescriptionPaddingLeft: "125px",
        DescriptionColumnSpan: 1,
        BackgroundColor: "#FFFFFF",
        IsRowVisible: true,
        IsRowJustAddedOrMoved: false,
        formattedPrice: 0.0,
      };
      courses[courseIndex].push(subChildRecord);
  }

  let foodMenuPayload = { ...foodMenu };
    courses.map((data, i) => {
      let ItemAddedCourses = {
        ...foodMenuPayload.Courses[i],
        Items: data,
        NextItemId: nextItemId[i] === 0 ? 1 : nextItemId[i],
      };
      let allCourses = [...foodMenuPayload.Courses];
      allCourses.splice(i, 1, ItemAddedCourses);
      foodMenuPayload = { ...foodMenuPayload, Courses: allCourses };
    });

    dispatch(COMMON_SERVICES.putFoodMenuServices(foodMenuPayload, siteId.get())).then(() =>
      setInitialList({ initial: null })
    );
  }

  const cancelSaveMenuChanges = () => {
    setCancelMenuChanges(false);
    setCancelChanges(true);
    setFoodMenu(getFoodMenuTabDataState);
    dispatch(COMMON_SERVICES.getFoodMenuTabServices(siteId.get()));
  }

  useEffect(() => {
    setToggleLoader(false);
    if (getFoodMenuTabDataStatus === API_STATUSES.REQUEST) {
      setToggleLoader(true);
    }
  }, [getFoodMenuTabDataStatus]);

  const popUpOpener = () => {
    if (checkedSharedCheckbox) {
      setShowModal2(true);
    } else {
      setShowModal(true);
    }
  }

  const collapseAll = () => {
    let temp = [...list];
    temp.forEach((item) => {
      item.forEach((item1) => {
        if (!Array.isArray(item1.group)) item1.group.parent[0].expand = false;
        else item1.item.parent[0].expand = false;
      });
    });
    setList([...temp]);
  }

  const expandAll = () => {
    list.map((courseMap) => {
      courseMap.forEach((itemListMap) => {
        if (itemListMap.group) {
          if (itemListMap.group.parent) {
            itemListMap.group.parent[0].expand = true;
          }
          if (itemListMap.group.child && itemListMap.group.child.length > 0) {
            itemListMap.group.child.map((groupChildMap) => {
              groupChildMap.expand = true;
              if (groupChildMap.subChild && groupChildMap.subChild.length > 0) {
                groupChildMap.subChild.map((subChildMap) => {
                  subChildMap.expand = true;
                });
              }
            });
          }
        }
        if (itemListMap.item) {
          if (itemListMap.item.parent) {
            itemListMap.item.parent[0].expand = true;
          }
          if (itemListMap.item.child && itemListMap.item.child.length > 0) {
            itemListMap.item.child.map((subChildMap) => {
              subChildMap.expand = true;
            });
          }
        }
      });
      setList([...list]);
    });
  }

  function removeExpand(arr) {
    let temp = JSON.stringify(arr);
    temp = temp.replace(/,"expand":false/g, "");
    temp = temp.replace(/,"expand":true/g, "");

    return temp;
  }

  const showPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: 444,
      width: "calc(100% - 40px)",
      bgcolor: "background.paper",
      borderRadius: "5px",
      overflow: "hidden",
      padding: "0 15px",
    };
    return (
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>
              {t("Are_you_sure_you_want_to_share_menus")}?{" "}
              {t("This_will_delete_all_but_the_first_menu")},{" "}
              {t("and_use_that_first_menu_for_all_courses")}
            </p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={() => {
                  setCheckedSharedCheckbox(true);
                  dispatch(COMMON_SERVICES.putSharedMenuCheckboxServices(true, siteId.get()));
                  setShowModal(false);
                  setSharedMenuChange(true);
                }}
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  setCheckedSharedCheckbox(checkedSharedCheckbox);
                  setShowModal(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  }

  const shouldSaveMenuChangesBeDisabled = () => {
    return (isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role) || isSaveMenuDisabled);
  }

  const showPopupBox2 = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showModal2}
        onClose={() => setShowModal2(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Are_you_sure_you_want_a_separate_menu_for_each_course")}?</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={() => {
                  setCheckedSharedCheckbox(false);
                  dispatch(
                    COMMON_SERVICES.putSharedMenuCheckboxServices(false, siteId.get())
                  );
                  setSharedMenuChange(true);

                  setShowModal2(false);
                }}
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  setCheckedSharedCheckbox(checkedSharedCheckbox);
                  setShowModal2(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  }

  return (
    <Container>
      {showPopupBox()}
      {showPopupBox2()}
      <HeaderWrapper>
        <div className="header">
          <p className="checkbox-label"></p>
          <div className="checkbox-wrapper">
            <FormControlLabel
              control={
                <Checkbox
                  disabled={
                    isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role)
                  }
                  checked={isFoodEnable ? isFoodEnable : false}
                  icon={<UncheckIcon />}
                  checkedIcon={<CheckIcon />}
                  onChange={handleOnChange}
                />
              }
              label={t("Food_&_Beverage_enabled")}
            />
          </div>
          {isLoading && <span>Loading...</span>}
        </div>
      </HeaderWrapper>
      <BodyWrapper>
        <TopSection>
          <AccordionStyled>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <h3>{t("Order_fulfillment")}</h3>
              </AccordionSummary>
              <AccordionDetails>
                <div className="inner-menu">
                  <div className="fulfillment-main-box">
                    <div>
                      <p className="checkbox-label"></p>
                      <div className="checkbox-wrapper">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={fbOrdersSettings.get().fillOrdersHere}
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                              // ToDO: Move Above on Change logic inside handleOnChangeShowOrder function
                              onChange={(e) =>
                                handleOnChangeShowOrder(e, "fillOrdersHere")
                              }
                            />
                          }
                          label={t("Show_orders_(POS_form)")}
                        />
                      </div>
                    </div>
                    {fbOrdersSettings.get().fillOrdersHere ? (
                      <>
                        <div>
                          <p className="checkbox-label">
                            <AudioIcon /> {t("Audible_alert")}
                          </p>
                          <div className="checkbox-wrapper">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    fbOrdersSettings.get().beepOnNewOrder
                                  }
                                  icon={<UncheckIcon />}
                                  checkedIcon={<CheckIcon />}
                                  onChange={(e) =>
                                    handleOnChangeShowOrder(e, "beepOnNewOrder")
                                  }
                                />
                              }
                              label={t("When_new_order_received")}
                            />
                          </div>
                          <div className="checkbox-wrapper">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    fbOrdersSettings.get().beepWhileOrderPending
                                  }
                                  icon={<UncheckIcon />}
                                  checkedIcon={<CheckIcon />}
                                  onChange={(e) =>
                                    handleOnChangeShowOrder(
                                      e,
                                      "beepWhileOrderPending"
                                    )
                                  }
                                />
                              }
                              label={t("While_orders_pending")}
                            />
                          </div>
                        </div>
                        <div>
                          <p className="checkbox-label">
                            <ChatIcon />
                            {t("Pop-up_alert")}
                          </p>
                          <div className="checkbox-wrapper">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    fbOrdersSettings.get().popupOnNewOrder
                                  }
                                  icon={<UncheckIcon />}
                                  checkedIcon={<CheckIcon />}
                                  onChange={(e) =>
                                    handleOnChangeShowOrder(
                                      e,
                                      "popupOnNewOrder"
                                    )
                                  }
                                />
                              }
                              label={t("When_new_order_received")}
                            />
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </AccordionStyled>
        </TopSection>
        <AccordionStyled>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <h3>{t("Menu")}</h3>
            </AccordionSummary>
            <AccordionDetails>
              <MenuSection>
                <TabContext value={tabValue}>
                  <Filter>
                    <TabList onChange={handleSharedMenusTabChange}>
                      {foodMenu?.Courses?.length > 0 ? (
                        foodMenu.Courses.map((v, index) => {
                          if (v.Title !== "Shared") {
                            return (
                              <Tab
                                label={v.Title}
                                value={v.CourseNumber.toString()}
                                key={`${v.CourseNumber}_${index}`}
                              />
                            );
                          }
                        })
                      ) : null
                    }
                    </TabList>
                    <Tooltip title={t("Shared_menu")}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkedSharedCheckbox}
                            icon={<UncheckIcon />}
                            checkedIcon={<CheckIcon />}
                            onChange={popUpOpener}
                          />
                        }
                        label={t("Shared_menu")}
                      />
                    </Tooltip>
                  </Filter>
                  {foodMenu?.Courses?.length > 0 ? (
                    foodMenu.Courses.map((v, courseIndex) => (
                      <TabPanel
                        value={v.CourseNumber.toString()}
                        key={`${v.CourseNumber}_${courseIndex}`}
                      >
                        <div className="filter-data">
                          <PromptAccept>
                            <FoodMenuFilter
                              holes={v.Holes}
                              handleOnSelectHoles={handleOnSelectHoles}
                              parentIndex={courseIndex}
                            />
                          </PromptAccept>
                          <ItemSection>
                            <HoursSection>
                              <div className="hour-selection-wrapper">
                                <FoodOrderHours
                                  parentIndex={courseIndex}
                                  selectedHours={v}
                                  Hours={Hours}
                                  Minutes={Minutes}
                                  calculateTotalValue={calculateTotalValue}
                                  handleOnChangeHours={handleOnChangeHours}
                                />
                              </div>
                              <div className="save-menu-parent">
                                <div className="save-changes-btn-wrapper">
                                  <Tooltip title={t("Cancel_menu_changes")}>
                                    <Button
                                      disabled={isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)}
                                      onClick={() => {
                                        if (JSON.stringify(foodMenu) !== JSON.stringify(compareFoodMenu) || removeExpand(list) !== initialList.initial) {
                                          setCancelMenuChanges(true);
                                        }
                                      }}
                                    >
                                      {t("Cancel_menu_changes")}
                                    </Button>
                                  </Tooltip>
                                  <Tooltip title={t("Save_menu_changes")}>
                                    <span>
                                      <Button
                                        disabled={shouldSaveMenuChangesBeDisabled()}
                                        onClick={saveMenuChanges}
                                        style={{
                                          background: shouldSaveMenuChangesBeDisabled() ? "" : "#bc9b6a",
                                          color: shouldSaveMenuChangesBeDisabled() ? "" : "#ffffff",
                                          borderColor: shouldSaveMenuChangesBeDisabled() ? "" : "transparent",
                                          cursor: shouldSaveMenuChangesBeDisabled() ? "not-allowed" : "auto"
                                        }}
                                      >
                                        {t("Save_menu_changes")}
                                      </Button>
                                    </span>
                                  </Tooltip>
                                </div>
                              </div>
                            </HoursSection>
                            <GroupItemSection>
                              <div className="group-item-header">
                                <div className="add-group-btn-wrapper">
                                  <Tooltip title={t("Add_group")}>
                                    <Button
                                      onClick={() =>
                                        addField("group", courseIndex)
                                      }
                                    >
                                      <AddIcon />
                                      {t("Add_group")}
                                    </Button>
                                  </Tooltip>
                                  <Tooltip title={t("Add_item")}>
                                    <Button
                                      onClick={() =>
                                        addField("item", courseIndex)
                                      }
                                    >
                                      <AddIcon />
                                      {t("Add_item")}
                                    </Button>
                                  </Tooltip>
                                </div>
                                <div className="collapse-expand-btn-wrapper">
                                  <button onClick={() => collapseAll()}>
                                    {t("Collapse_all")}
                                  </button>{" "}
                                  |{" "}
                                  <button onClick={() => expandAll()}>
                                    {t("Expand_all")}
                                  </button>
                                </div>
                              </div>
                              <FoodItems>
                                {list?.length > 0 ? (
                                  list[courseIndex].map((v, i) =>
                                   v?.group?.parent?.length > 0 ? (
                                      <Accordion
                                        expanded={v.group.parent[0].expand}
                                        key={`group_${i}`}
                                      >
                                        <AccordionSummary
                                          aria-controls="panel1a-content"
                                          id="panel1a-header"
                                          expandIcon={
                                            <ExpandMoreNormalIcon
                                              onClick={(e) =>
                                                toggleAcordion(
                                                  e,
                                                  courseIndex,
                                                  i,
                                                  "group",
                                                  v
                                                )
                                              }
                                            />
                                          }
                                        >
                                          <AddGroup
                                            handleOnDelete={handleOnDelete}
                                            handleOnAddButton={
                                              handleOnAddButton
                                            }
                                            i={i}
                                            parentIndex={courseIndex}
                                            listType={"group"}
                                            DummyFoodImage={DummyFoodImage}
                                            shiftUp={shiftUp}
                                            shiftDown={shiftDown}
                                            foodDetails={v}
                                            handleOnChangeTitle={
                                              handleOnChangeTitle
                                            }
                                            handleOnChangePrice={
                                              handleOnChangePrice
                                            }
                                            changeOrder={changeOrder}
                                            img={v.group.parent[0].image}
                                            toggleAcordion={toggleAcordion}
                                            list={list}
                                            setList={setList}
                                          />
                                        </AccordionSummary>
                                        {v?.group?.child?.length > 0 ? (
                                          <AccordionDetails>
                                            <ItemsWrapper>
                                              {v.group.child.map(
                                                (child, index) => (
                                                  <AddItem
                                                    key={`group_${child.itemNumber}`}
                                                    handleOnDelete={
                                                      handleOnDelete
                                                    }
                                                    handleOnAddButton={
                                                      handleOnAddButton
                                                    }
                                                    index={index}
                                                    i={i}
                                                    parentIndex={courseIndex}
                                                    listType={"group"}
                                                    DummyFoodImage={
                                                      DummyFoodImage
                                                    }
                                                    subChild={
                                                      child.subChild
                                                        ? child.subChild
                                                        : []
                                                    }
                                                    addSubchild={addSubchild}
                                                    handleOnDeleteSubChild={
                                                      handleOnDeleteSubChild
                                                    }
                                                    handleOnChangeTitle={
                                                      handleOnChangeTitle
                                                    }
                                                    handleOnChangePrice={
                                                      handleOnChangePrice
                                                    }
                                                    data={child}
                                                    toggleAcordion={
                                                      toggleAcordion
                                                    }
                                                    shiftUp={shiftUp}
                                                    shiftDown={shiftDown}
                                                    shiftUpSubChild={
                                                      shiftUpSubChild
                                                    }
                                                    expandSubGroup={
                                                      child.expand
                                                    }
                                                    toggleAcordionSubGroup={
                                                      toggleAcordionSubGroup
                                                    }
                                                    foodDetails={v}
                                                    shiftUpDownChild={
                                                      shiftUpDownChild
                                                    }
                                                    img={v.group.child[0].image}
                                                    list={list}
                                                    setList={setList}
                                                  />
                                                )
                                              )}
                                            </ItemsWrapper>
                                          </AccordionDetails>
                                        ) : null
                                      }
                                      </Accordion>
                                    ) : v?.item?.parent?.length > 0 ? (
                                        <Accordion
                                          expanded={v.item.parent[0].expand}
                                          key={`panel1a-content_${i}`}
                                        >
                                          <AccordionSummary
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            expandIcon={
                                              <ExpandMoreNormalIcon
                                                onClick={(e) => {
                                                  toggleAcordion(
                                                    e,
                                                    courseIndex,
                                                    i,
                                                    "item",
                                                    v
                                                  );
                                                }}
                                              />
                                            }
                                          >
                                            <AddGroup
                                              handleOnDelete={handleOnDelete}
                                              handleOnAddButton={
                                                handleOnAddButton
                                              }
                                              i={i}
                                              parentIndex={courseIndex}
                                              listType={"item"}
                                              DummyFoodImage={DummyFoodImage}
                                              shiftUp={shiftUp}
                                              shiftDown={shiftDown}
                                              foodDetails={v}
                                              handleOnChangeTitle={
                                                handleOnChangeTitle
                                              }
                                              handleOnChangePrice={
                                                handleOnChangePrice
                                              }
                                              changeOrder={changeOrder}
                                              img={v.item.parent[0].image}
                                              list={list}
                                              setList={setList}
                                            />
                                          </AccordionSummary>
                                          {v.item &&
                                            v.item.child &&
                                            v.item.child.length > 0 ? (
                                            <AccordionDetails>
                                              <ItemsWrapper>
                                                {v.item.child.map(
                                                  (child, index) => (
                                                    <AddItem
                                                      key={`item_${child.itemNumber}`}
                                                      handleOnDelete={
                                                        handleOnDelete
                                                      }
                                                      handleOnAddButton={
                                                        handleOnAddButton
                                                      }
                                                      index={index}
                                                      i={i}
                                                      parentIndex={courseIndex}
                                                      listType={"item"}
                                                      DummyFoodImage={
                                                        DummyFoodImage
                                                      }
                                                      subChild={[]}
                                                      data={child}
                                                      handleOnChangeTitle={
                                                        handleOnChangeTitle
                                                      }
                                                      handleOnChangePrice={
                                                        handleOnChangePrice
                                                      }
                                                      toggleAcordion={
                                                        toggleAcordion
                                                      }
                                                      shiftUp={shiftUp}
                                                      shiftDown={shiftDown}
                                                      shiftUpSubChild={
                                                        shiftUpSubChild
                                                      }
                                                      expandSubGroup={
                                                        v.item.parent[0].expand
                                                      }
                                                      foodDetails={v}
                                                      shiftUpDownChild={
                                                        shiftUpDownChild
                                                      }
                                                      list={list}
                                                      setList={setList}
                                                    />
                                                  )
                                                )}
                                              </ItemsWrapper>
                                            </AccordionDetails>
                                          ) : null
                                        }
                                        </Accordion>
                                    ) : null
                                  )
                                ) : (
                                  <>No Items</>
                                )}
                              </FoodItems>
                            </GroupItemSection>
                          </ItemSection>
                        </div>
                      </TabPanel>
                    ))
                  ) : null}
                </TabContext>
              </MenuSection>
            </AccordionDetails>
            {toggleLoader && <Loader />}
            <AlertModal
              handleOnSubmit={handleOnDeleteSubmit}
              title={t("Confirm")}
              content={`${t("Delete")} ${getDeleteValues ? getDeleteValues?.title ? getDeleteValues?.title : t("This_Item")
                  : getDeleteValuesForChild.title ? getDeleteValuesForChild.title : t("This_Item")} ?`}
              isOpen={openDeleteItemAlert}
              setOpenAlert={setOpenDeleteItemAlert}
              setDeleteValues={setDeleteValues}
            />
            <AlertModal
              title={t("Missing_Information")}
              content={t("Description_is_needed_for_each_food_item")}
              isOpen={descriptionValidationAlert}
              setOpenAlert={setDescriptionValidationAlert}
              validation={true}
            />

            <AlertModal
              handleOnSubmit={cancelSaveMenuChanges}
              title={t("Confirm")}
              content={`${t("Discard_changes_to_F&B_menu_settings")}?`}
              isOpen={cancelMenuChanges}
              setOpenAlert={cancelMenuChanges}
            />
          </Accordion>
        </AccordionStyled>
      </BodyWrapper>
    </Container>
  );
};

export default FBSettings;
